// price_config.js

export const VATrate = 0.2;

export const pricing = {
  image: { price: 5, sku: '1', name: 'Digital image' },
  credits: [
    { name: 2, price: 9.17, sku: '3' },
    { name: 3, price: 12.5, sku: '4' },
    { name: 5, price: 16.67, sku: '5' },
    { name: 10, price: 25, sku: '6' }
  ]
};



// WEBPACK FOOTER //
// ./src/utils/price_config.js